import {Button, Card, CardBody, CardHeader, Typography,} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {BranchGrid} from "./grid";
import {BranchForm} from "./form";
import {getBranches, getFieldBranchesByFieldId} from "../../../services/branch/branch";
import {CardFooterPaginator} from "../../system/cardFooterPaginator";
import SelectInput from "../../system/select";
import {getFields} from "../../../services/field/field";
import {PaginateContext} from "../../../context/paginate";

export function BranchManagement() {

  const [branches, setBranches] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [gridRowCount, setGridRowCount] = useState(10);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridSelectedRow, setGridSelectedRow] = useState(null);
  const [gridTotalRowCount, setGridTotalRowCount] = useState(0);
  const [sortBy, setSortBy] = useState("id")
  const [sortType, setSortType] = useState(false);
  const [from, setFrom] = useState((gridCurrentPage - 1) * gridRowCount + 1);
  const [to, setTo] = useState((gridCurrentPage) * gridRowCount);
  const [lastDataRefresh, setLastDataRefresh] = useState(null);

  const [branchId, setBranchId] = useState(null);
  const [fieldId, setFieldId] = useState(null);

  useEffect(() => {
    if ((gridCurrentPage) * gridRowCount <= gridTotalRowCount) {
      setTo((gridCurrentPage) * gridRowCount)
    } else {
      setTo(gridTotalRowCount)
    }
    if (gridTotalRowCount === 0) {
      setFrom(0)
    } else {
      setFrom((gridCurrentPage - 1) * gridRowCount + 1)
    }
  }, [gridCurrentPage, gridRowCount, gridTotalRowCount]);

  async function getData(paginate) {
    const result = await getBranches(paginate);
    if (result.status === 200) {
      const {branchList, total_count} = result.data;
      setBranches(branchList || []);
      setGridTotalRowCount(total_count);
    }
  }

  useEffect(() => {
    const paginateParams = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(gridRowCount),
      "offset": (parseInt(gridCurrentPage) - 1) * parseInt(gridRowCount),
    })

    const filterParams = new URLSearchParams({})

    if (fieldId) {
      filterParams.append("field_id", fieldId)
    }

    if (branchId) {
      filterParams.append("branch_id", branchId)
    }

    for (const [key, value] of filterParams.entries()) {
      paginateParams.append(key, value);
    }

    const paginate = paginateParams.toString()

    getData(paginate)
  }, [fieldId, branchId, lastDataRefresh, gridCurrentPage, gridRowCount, sortBy, sortType]);

  return (
    <PaginateContext.Provider value={{
      setSortBy: setSortBy,
      sortType: sortType,
      setSortType: setSortType,
      active: gridCurrentPage,
      setActive: setGridCurrentPage,
      totalRows: gridTotalRowCount,
      rowsCount: gridRowCount,
      setRowsCount: setGridRowCount,
      from: from,
      to: to,
    }}>
      <div className="">
        <BranchForm branch={gridSelectedRow} open={modalOpen} setOpen={setModalOpen}
                    setLastDataRefresh={setLastDataRefresh} setGridSelectedRow={setGridSelectedRow}/>
        <Card className="pt-8">
          <CardHeader floated={true} shadow={false} className="rounded-none">
            <div className="mb-8 flex items-center justify-between gap-8">
              <Typography variant="h5" color="blue-gray">گرایش‌مباشر</Typography>
              <Button onClick={() => {
                setGridSelectedRow(null);
                setModalOpen(true);
              }} variant="outlined">جدید</Button>
            </div>
          </CardHeader>
          <CardBody className="overflow-x-auto w-full">

            <div className="grid grid-cols-1 gap-4 mb-8 md:grid-cols-2 xxl:grid-cols-3">

              <div className="flex flex-col">
                <SelectInput
                  label={"رشته"}
                  defaultValue={fieldId}
                  autoLoadService={getFields}
                  onChange={setFieldId}
                />
              </div>

              <div className="flex flex-col">
                <SelectInput
                  label={"گرایش"}
                  defaultValue={branchId}
                  refreshSignal={fieldId}
                  autoLoadService={getFieldBranchesByFieldId}
                  autoLoadServiceData={fieldId}
                  autoLoadRender={({title}) => {
                    return title
                  }}
                  onChange={setBranchId}
                />
              </div>

            </div>

            <BranchGrid
              branches={branches}
              setModalOpen={setModalOpen}
              setSelectedRow={setGridSelectedRow}
            />
          </CardBody>
          <CardFooterPaginator/>
        </Card>
      </div>
    </PaginateContext.Provider>
  );
}